module.exports = __webpack_public_path__ + "img/seating-gallery-3.cf4a3652.jpg";